import React, { createContext, memo, useContext, useMemo } from "react";
import PropTypes from "prop-types";

const HeadingContext = createContext("global.heading");

const HeadingContextProvider = memo(({ heading, children }) => {
    return (
        <HeadingContext.Provider value={heading}>
            {children}
        </HeadingContext.Provider>
    );
});

HeadingContextProvider.defaultProps = {
    children: null,
    heading: undefined,
};

HeadingContextProvider.propTypes = {
    children: PropTypes.node,
    heading: PropTypes.string,
};

HeadingContextProvider.displayName = "HeadingContextProvider";

export const useHeadingContext = () => {
    const heading = useContext(HeadingContext);
    return useMemo(() => ({ heading }), [heading]);
};

export default HeadingContextProvider;
